import _ from 'lodash';
import React from 'react';

import classnames from 'classnames';

import Checkbox from '../Checkbox';
import './styles';

export default class Radio extends React.Component {

  onChange(value) {
    this.props.onChange(value);
  }

  render() {
    return (
      <div className={classnames('Radio ui', 'form', this.props.className)}>
        <div className={classnames(this.props.fieldType, 'fields m-b-0')}>
          {_.map(this.props.selections, (selection, index) => {
            return (
              <div
                className={classnames('field', {active: this.props.selected === selection.value})}
                key={selection.value || index}
              >
                <Checkbox
                  type="radio"
                  className={"radio"}
                  name={this.props.name}
                  checked={this.props.selected === selection.value}
                  onChange={this.onChange.bind(this, selection.value)}
                  label={selection.display || selection.value}
                />
              </div>
            );
          })}

        </div>
      </div>
    );
  }
}

Radio.propTypes = {
  onChange: React.PropTypes.func.isRequired,
};



// WEBPACK FOOTER //
// ./~/sp-components/components/Radio/index.jsx